import type { ElementType, ReactNode } from "react";
import { cn } from "../../lib/utils.ts";

export type OperatorSurfaceDensity = "compact" | "default" | "roomy" | "none";

export const operatorSurfaceClassName = (
  density: OperatorSurfaceDensity = "default",
  raised = false,
) => cn(
  raised ? "rounded-xl border border-slate-200 bg-white" : "rounded-lg border border-slate-200 bg-white",
  density === "compact" && "p-4",
  density === "default" && "p-6",
  density === "roomy" && "p-8",
  raised && "shadow-sm",
);

export function OperatorSurface({
  as: Component = "section",
  children,
  className,
  density = "default",
  raised = false,
}: {
  as?: ElementType;
  children: ReactNode;
  className?: string;
  density?: OperatorSurfaceDensity;
  raised?: boolean;
}) {
  return <Component className={cn(operatorSurfaceClassName(density, raised), className)}>{children}</Component>;
}
